var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrees3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 362,
    viewBox: "0 0 106 362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trees-3",
    transform: "translate(-576 -4017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3900",
    "data-name": "Group 3900",
    transform: "translate(-107 -91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2996",
    "data-name": "Rectangle 2996",
    d: "M53,0h53a0,0,0,0,1,0,0V189a53,53,0,0,1-53,53h0A53,53,0,0,1,0,189V53A53,53,0,0,1,53,0Z",
    transform: "translate(683 4108)",
    fill: "#5d7e63"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3003",
    "data-name": "Rectangle 3003",
    width: 15,
    height: 253,
    rx: 7.5,
    transform: "translate(620.833 4126)",
    fill: "#393834"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M3,34.717a2,2,0,0,1,3.993,0l2.882,50.1a2,2,0,0,1-2,2.115H2.118a2,2,0,0,1-2-2.115Z",
    transform: "matrix(0.891, 0.454, -0.454, 0.891, 664.672, 4107.723)",
    fill: "#393834"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    d: "M3,34.716a2,2,0,0,1,3.993,0l2.882,50.1a2,2,0,0,1-2,2.115H2.118a2,2,0,0,1-2-2.115Z",
    transform: "matrix(0.891, -0.454, 0.454, 0.891, 586.455, 4161.968)",
    fill: "#393834"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrees3);
export default __webpack_public_path__ + "static/media/trees-3.8b94a2b36f01b38d1c418fdf9f9ca444.svg";
export { ForwardRef as ReactComponent };